export default __webpack_public_path__ + "static/media/trashDark.75570343.svg";